/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';

const useGTPSubscriptionFeedbackCards = (
  goalUID,
  isGTP,
  isSubscribed,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `v1/feedback/card/?object_uid=${goalUID}&feedback_type=gtp_subscription`;

  const { data, isValidating, ...rest } = useFetch(
    isSubscribed && isGTP ? key : null,
    { useCamelCase: false },
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    subscriptionFeedbackCards: data?.data ?? [],
    isValidating,
    ...rest
  };
};

export default useGTPSubscriptionFeedbackCards;
